import React, { useEffect } from "react";
import care6_ls2 from "../../images/care6_ls2.png";
import { Helmet } from "react-helmet";

function About() {
  useEffect(() => {
    const revealElements = document.querySelectorAll(".fade-in, .slide-left, .slide-right");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    revealElements.forEach((element) => observer.observe(element));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="about-page">
            <Helmet>
          <title>About Us | Wholistic Nursing Care</title>
        <meta name="description" content="Learn about Wholistic Nursing Care, our mission, vision, and dedicated approach to providing holistic healthcare services in Nairobi." />
        <meta name="keywords" content="about wholistic care, nursing services, holistic healthcare Nairobi, home-based care team" />
        <link rel="canonical" href="https://wholistic.netlify.app/about" />
      </Helmet>
      
      {/* Who We Are Section */}
      <section className="who-we-are fade-in">
        <h2>Who We Are</h2>
        <p>
          At <strong>Wholistic Home-Based Care</strong>, we believe in treating the person as a whole—mind, body, and soul. 
          With a compassionate team of healthcare professionals, we specialize in providing tailored home and travel-based care 
          that meets the unique needs of every individual.
        </p>
      </section>

      {/* Our Approach Section */}
      <section className="our-approach slide-left">
        <div className="approach-content">
          <div className="approach-text">
            <h2>Our Approach</h2>
            <p>
              Our approach to care is <strong>wholistic</strong> and <strong>personalized</strong>. We collaborate closely with families and healthcare professionals 
              to develop customized care plans that address both physical health and emotional well-being. 
              Whether managing chronic conditions, offering companionship, or ensuring safe mobility, 
              we’re committed to supporting our clients' overall wellness.
            </p>
            <p>
              We believe that **healing and care** extend beyond physical treatment. That’s why we prioritize 
              emotional and mental well-being through compassionate caregiving and active listening.
            </p>
          </div>
          <img src={care6_ls2} alt="Our Approach" className="approach-image" />
        </div>
      </section>

      {/* Our Values Section */}
      <section className="our-values slide-right">
        <h2>Our Core Values</h2>
        <div className="values-container">
          <div className="value-item">
            <h3>Compassion</h3>
            <p>We treat every client with the utmost kindness, empathy, and understanding.</p>
          </div>
          <div className="value-item">
            <h3>Integrity</h3>
            <p>We uphold transparency and honesty in all our interactions and services.</p>
          </div>
          <div className="value-item">
            <h3>Respect</h3>
            <p>We honor the dignity and individuality of every person we care for.</p>
          </div>
          <div className="value-item">
            <h3>Excellence</h3>
            <p>We are committed to delivering top-quality, reliable care every day.</p>
          </div>
        </div>
      </section>

      {/* Mission & Vision Section */}
      <section className="mission-vision fade-in">
        <div className="vision">
          <h3>Our Vision</h3>
          <p>To be a renowned agency known for delivering exceptional home-based care that enhances lives and fosters independence.</p>
        </div>
        <div className="mission">
          <h3>Our Mission</h3>
          <p>To provide accessible, quality healthcare in the comfort of your home, ensuring both physical and emotional well-being.</p>
        </div>
      </section>


      {/* Call to Action */}
      <section className="about-cta slide-left">
        <h2>Let Us Take Care of Your Loved Ones</h2>
        <p>Contact us today to discover how we can provide compassionate, personalized care for your family.</p>
        <a href="/contact" className="btn-cta">Get in Touch</a>
      </section>

    </div>
  );
}

export default About;
